const {cbc} = require("./callback-chain");

const csArr = (arr, next) => cbc([], [...arr.map((fn) => (_, next) => fn((o) => next([..._, o]))), next]);
exports.csArr = csArr;
